import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import EmptyPageAvatar from '../../common/components/EmptyPageAvatar';

const ExclusionsEmptyPage: FC<ExclusionsEmptyPageProps> = () => {
  const { classes } = useStyles();
  return (
    <EmptyPageAvatar
      text={
        <Typography component='div' className={classes.exclusionsEmptyPage}>
          Exclusions are set on the Issues page. This screen will show the
          following:
          <ul>
            <li>Issues that are excluded</li>
            <li>Issues that are excluded for some time (snooze)</li>
            <li>Applications manually set to be irrelevant</li>
            <li>Policies disabled from the Issue page</li>
          </ul>
        </Typography>
      }
    />
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  exclusionsEmptyPage: {
    color: theme.palette.common.white,
    lineHeight: 1.2,
    '& ul': {
      paddingInlineStart: theme.spacing(2),
      marginBlock: theme.spacing(1),
      listStyle: 'inside',
      listStylePosition: 'outside',
    },
    '& li': {
      lineHeight: 1.5,
    },
    '& a': {
      color: 'inherit',
    },
  },
}));

export interface ExclusionsEmptyPageProps {}

export default ExclusionsEmptyPage;
